module.exports = __webpack_public_path__ + "img/sheep_des_2.4eccf963.jpg";